<template>
  <div>
    not found 404
  </div>
</template>

<script>
export default {
  name: 'NotFoundComponent',
  data () {
    return {

    }
  },
  mounted () {
    this.$router.replace({name: 'indexDefault'})
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NotFoundComponent.vue